import { render } from "./EventComp.vue?vue&type=template&id=03e57c7c"
import script from "./EventComp.vue?vue&type=script&lang=js"
export * from "./EventComp.vue?vue&type=script&lang=js"

import "./EventComp.vue?vue&type=style&index=0&id=03e57c7c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__